<template>
  <div>
    <div class="d-sm-flex align-items-center justify-content-between mb-4">
      <h1 class="h3 mb-0 text-gray-800">{{ data.user.name }}'s Online Test Detail</h1>
    </div>
    <div class="row">
      <div class="col-4">
        <overview :data="data"/>
        <test-overview :data="data" class="mt-3"/>
      </div>

      <div class="col">
        <test-result :data="data"/>
      </div>

    </div>
  </div>
</template>

<script>
import overview from '@/pages/online_test/component/overview'
import test_overview from '@/pages/online_test/component/test_overview'
import test_result from '@/pages/online_test/component/test_result'

export default {
  components:{
    overview,
    'test-overview': test_overview,
    'test-result': test_result,
  },
  data(){
    return {
      data: {
        id: this.$route.query.id,
        user: {
          id: '',
          name: '',
          photo: {
            file_name: '',
          },
        },
        online_test:{
          created_at: '',
          score: 0,
          online_test: {
            name: ''
          }
        }
      }
    }
  },
  async created(){
    await this.get_data()
  },
  methods:{
    async get_data(){
      try{
        var response = await axios.get(base_url+'/online-test?id='+this.$route.query.id)

        var response_data = response.data
        if(response_data.status == "success"){
          // console.log(this.online_test)
          this.data.user = response_data.data.user
          this.data.online_test.created_at = moment(response_data.data.created_at).format('DD MMMM YYYY')
          this.data.online_test.score = response_data.data.score
          this.data.online_test.online_test = response_data.data.online_test
        }
        else
          this.$toasted.show(response_data.message)
      } catch(e){
        this.$toasted.show(e)
      }
    },
  }
}
</script>
